import React, { useState, useEffect } from 'react';

import { UserAddOutlined, CopyOutlined } from '@ant-design/icons';
import { Modal, Input, Button, Space } from 'antd';
import { toast } from 'react-toastify';
import { Partner } from 'src/interfaces/entities/partners';

export default function CreateUserLink(
	{
		row,
	}: { row: Partner }
) {
	const [ open, setOpen, ] = useState<boolean>(false);
	const [ signUpLink, setSignUpLink, ] = useState<string>('');

	const generateToken = () => {
		const payload = {
			partner_id: row.id,
			role: 'partner',
			expiration: Date.now() + (10 * 60 * 1000),
		};
		
		const newToken = btoa(JSON.stringify(payload));
		
		const publicUrl = process.env.REACT_APP_PUBLIC_URL || window.location.origin;
		setSignUpLink(`${publicUrl}/cadastro?token=${newToken}`);
	};

	const handleCopyLink = async () => {
		try {
			await navigator.clipboard.writeText(signUpLink);
			toast.success('Link copiado para área de transferência!', { autoClose: 2000, });
		} catch (error) {
			toast.error('Erro ao copiar link!', { autoClose: 2000, });
		}
	};

	const handleUpdateToken = () => {
		generateToken();
		toast.success('Token re-gerado com sucesso!', { autoClose: 2000, });
	};

	useEffect(() => {
		if (open) {
			generateToken();
		}
	}, [ open, ]);

	return (
		<>
			<Button
				type="text"
				icon={<UserAddOutlined />}
				onClick={() => setOpen(true)}
			/>
			<Modal
				centered
				title={'Link de Criação de Usuário Parceiro'}
				open={open}
				onCancel={() => {
					setOpen(false);
					toast.info('Operação cancelada!', { autoClose: 1000, });
				}}
				footer={[
					<Button key="close" onClick={() => setOpen(false)}>
						Fechar
					</Button>,
					<Button key="update" type="primary" onClick={handleUpdateToken}>
						Atualizar
					</Button>,
				]}
				destroyOnHidden
			>
				<Space direction="vertical" size="middle" style={{ width: '100%', }}>
					<div>
						<label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', }}>
							Link de Cadastro:
						</label>
						<Input
							value={signUpLink}
							readOnly
							suffix={
								<Button
									type="text"
									icon={<CopyOutlined />}
									onClick={handleCopyLink}
									style={{ border: 'none', padding: '0 4px', }}
								/>
							}
						/>
					</div>
					<div style={{ fontSize: '12px', color: '#666', }}>
						Este link expira em 10 minutos após a geração.
					</div>
				</Space>
			</Modal>
		</>
	);
}